// Dependency-free carousel for the testimonials section. Scroll-snap does the
// swipe/scroll physics natively; this just adds prev/next buttons, dot
// indicators, and optional autoplay on top of that native scroll.
class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.testimonials__track');
    this.cards = Array.from(this.track.children);
    this.dotsWrap = this.querySelector('.testimonials__dots');
    this.prevBtn = this.querySelector('[data-action="prev"]');
    this.nextBtn = this.querySelector('[data-action="next"]');
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;

    if (this.cards.length <= 1) {
      if (this.prevBtn) this.prevBtn.hidden = true;
      if (this.nextBtn) this.nextBtn.hidden = true;
      return;
    }

    this.cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonials__dot';
      dot.setAttribute('aria-label', `Go to review ${i + 1}`);
      dot.addEventListener('click', () => this.scrollToIndex(i));
      this.dotsWrap.appendChild(dot);
    });
    this.dots = Array.from(this.dotsWrap.children);

    this.prevBtn.addEventListener('click', () => this.scrollToIndex(this.currentIndex() - 1));
    this.nextBtn.addEventListener('click', () => this.scrollToIndex(this.currentIndex() + 1));

    let scrollTimer;
    this.track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => this.updateDots(), 100);
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());

    this.updateDots();
    this.startAutoplay();
  }

  currentIndex() {
    const scrollLeft = this.track.scrollLeft;
    let closest = 0;
    let closestDist = Infinity;
    this.cards.forEach((card, i) => {
      const dist = Math.abs(card.offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closest = i;
        closestDist = dist;
      }
    });
    return closest;
  }

  scrollToIndex(index) {
    const clamped = (index + this.cards.length) % this.cards.length;
    this.track.scrollTo({ left: this.cards[clamped].offsetLeft, behavior: 'smooth' });
  }

  updateDots() {
    const idx = this.currentIndex();
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
  }

  startAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.scrollToIndex(this.currentIndex() + 1), this.interval);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);
